import React from 'react';
import BannerMainFull from '../maincomponent/Bannermainfull';


export default function About() {
  return (
    <>
<BannerMainFull />
    </>
   );
}
